import React from "react";

export default function PageTitle({ className, ...otherProps }) {
  const classNames = ["page-title", className].join(" ");
  return <span {...otherProps} className={classNames} />;
}
